import React from 'react'
import { AUTH_PREFIX_PATH } from 'configs/AppConfig'

export const publicRoutes = [
    {
        key: 'home',
        path: `/home`,
        component: React.lazy(() => import('views/app-views/whatsapp/LandingPages/index')),
    },
    {
        key: 'privacy-policy',
        path: `/privacy-policy`,
        component: React.lazy(() => import('views/app-views/whatsapp/LandingPages/PrivacyPolicy')),
    },
    {
        key: 'terms-of-service',
        path: `/terms`,
        component: React.lazy(() => import('views/app-views/whatsapp/LandingPages/TermsOfService')),
    },
    {
        key: 'refund-policy',
        path: `/refund-policy`,
        component: React.lazy(() => import('views/app-views/whatsapp/LandingPages/RefundPolicy')),
    },
    {
        key: 'plan-details',
        path: `/pricing/plan-detail/:id`,
        component: React.lazy(() => import('views/app-views/whatsapp/LandingPages/components/PlanDetailsPage')),
    },
    {
        key: 'error-page-1',
        path: `error-page-1`,
        component: React.lazy(() => import('views/auth-views/errors/error-page-1')),
    },
    {
        key: 'error-page-2',
        path: `${AUTH_PREFIX_PATH}/error-page-2`,
        component: React.lazy(() => import('views/auth-views/errors/error-page-2')),
    },
]

export const authRoutes = [
    {
        key: 'login',
        path: `/login`,
        component: React.lazy(() => import('views/app-views/whatsapp/Auth/LoginTwo')),
    },
    {
        key: 'register',
        path: `/register`,
        component: React.lazy(() => import('views/app-views/whatsapp/Auth/register/index')),
    },
    //add password reset
    {
        key: 'reset-password',
        path: `/reset-password`,
        component: React.lazy(() => import('views/app-views/whatsapp/Auth/ForgotPassword/ResetPassword')),
    },
    {
        key: 'forgot-password',
        path: `/forgot-password`,
        component: React.lazy(() => import('views/app-views/whatsapp/Auth/ForgotPassword/ForgotPassword')),
    },
    {
        key: 'otp-verification',
        path: `/otp-verification`,
        component: React.lazy(() => import('views/auth-views/authentication/register-1')),
    },
    {
        key: 'login-1',
        path: `${AUTH_PREFIX_PATH}/login-1`,
        component: React.lazy(() => import('views/auth-views/authentication/login-1')),
    },
    {
        key: 'login-2',
        path: `${AUTH_PREFIX_PATH}/login-2`,
        component: React.lazy(() => import('views/auth-views/authentication/login-2')),
    },
    {
        key: 'register-1',
        path: `${AUTH_PREFIX_PATH}/register-1`,
        component: React.lazy(() => import('views/auth-views/authentication/register-1')),
    },
    {
        key: 'register-2',
        path: `${AUTH_PREFIX_PATH}/register-2`,
        component: React.lazy(() => import('views/auth-views/authentication/register-2')),
    },
    // {
    //     key: 'forgot-password',
    //     path: `${AUTH_PREFIX_PATH}/forgot-password`,
    //     component: React.lazy(() => import('views/auth-views/authentication/forgot-password')),
    // },
]

export const protectedRoutes = [
    {
        key: 'Dashboard',
        path: `/dashboard`,
        component: React.lazy(() => import('views/app-views/whatsapp/Home/Index')),
    },
    {
        key: 'Platform Overview',
        path: `/platform-overview`,
        component: React.lazy(() => import('views/app-views/whatsapp/Home/PlatformOverview')),
    },
    {
        key: 'New Campaign',
        path: `/new-campaign`,
        component: React.lazy(() => import('views/app-views/whatsapp/Campaign/index')),
    },
    {
        key: 'Campaign History',
        path: `/campaign-history`,
        component: React.lazy(() => import('views/app-views/whatsapp/Campaign/CampaignHistory')),
    },
    {
        key: 'Users',
        path: `/users`,
        component: React.lazy(() => import('views/app-views/whatsapp/User/Users')),
    },
    {
        key: 'dashboard',
        path: `/dashboard`,
        component: React.lazy(() => import('views/app-views/whatsapp/Home/Index')),
    },

]